'use strict';

module.exports = locate;
function locate(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex);
  var underscore = value.indexOf('_', fromIndex);
  if (underscore === -1) {
    return asterisk;
  }
  if (asterisk === -1) {
    return underscore;
  }
  return underscore < asterisk ? underscore : asterisk;
}